const parseTemplate = (html: string): Document => new DOMParser().parseFromString(`<!doctype html><html><body>${html}</body></html>`, 'text/html')

const singleRootDiv = (document: Document): HTMLDivElement | null => {
    const elements = Array.from(document.body.children)
    return elements.length === 1 && elements[0] instanceof HTMLDivElement ? elements[0] : null
}

export const readEmailBackgroundColor = (html: string): string => singleRootDiv(parseTemplate(html))?.style.backgroundColor ?? ''

export const applyEmailBackgroundColor = (html: string, backgroundColor: string | null): string => {
    const document = parseTemplate(html)
    let root = singleRootDiv(document)

    if (!root && !backgroundColor) return html
    if (!root) {
        root = document.createElement('div')
        while (document.body.firstChild) root.appendChild(document.body.firstChild)
        document.body.appendChild(root)
    }

    if (backgroundColor) root.style.backgroundColor = backgroundColor
    else root.style.removeProperty('background-color')
    return document.body.innerHTML
}
